<ng-container *ngIf="showEmailUpdateModal">
  <mapfre-modal [modalOptions]="emailUpdateModal" [hideModal]="hideModal" (click)="resetHideModal()"
    (closeModal)="resetHideModal()">
    <div class="modal-body email-change-popup no-margin-top margin-bottom mb0" [ngClass]="{ 'modal-body-acmic-container': isAcmic}">
      <!-- <hr class="no-margin-bottom no-margin-top" /> -->

      <div class="modal-block text-center">
        <figure>
          <img src="./assets/img/images/expired.svg" alt="Otp" />
        </figure>
        <h3 class="edit-contact-title mt-2">
          {{"Confirm email update"}}
        </h3>
        <div class="info-consideration margin-top mt16" [ngClass]="{ 'dm-sans-medium': !isAcmic}">
          <div class="are-you-sure-txt">
            <!-- {{ "Are you sure you want to update" }} -->
              {{"Are you sure you want to update?"}}
          </div>
          <!-- <ng-container *ngIf="isAcmic; else otherMAState">
            <div class="confirm-title">{{ userDetails?.email?.address }}</div>
            <div>{{ "with the new email" }}</div>
            <div class="confirm-title">
              {{ editContactForm?.value?.contactEmail }}
            </div>
          </ng-container>
          <ng-template #otherMAState> -->
            <div class="email-frame-container">
              <p class="mb-3">
                <span class="left">Current email:</span>
                <span class="right">{{ userDetails?.email?.address }}</span>
              </p>
              <p class="mb-0">
                <span class="left">New email:</span>
                <span class="right">{{ editContactForm?.value?.contactEmail }}</span>
              </p>
            </div>
          <!-- </ng-template> -->
          
        </div>
        <div class="info-consideration confirm-subtitle margin-top mt16">
          <!-- {{
          "After you confirm, the previous email will no longer be valid for logging into your account."
        }} -->
        {{"After you confirm this change, your previous email will no longer be valid for logging into your account."}}
        </div>
      </div>

      <hr class="mt-3 mb-3 border-width" />

      <div class="email-actions edit-contact-btn text-right margin-top mt16">
        <mapfre-button (click)="resetHideModal()" additionalClasses="ghost secondary large-btn edit-contact-btns h56">{{
          "CANCEL_CONTACT" | translate }}
        </mapfre-button>
        <mapfre-button (click)="confirmNewEmail()" [ngClass]="{ 'edit-contact custom_loader': loader }"
          [disabledValue]="!loader" additionalClasses="basic primary large-btn mx-auto">
          {{ "CONFIRM_EMAIL_CONTACT" | translate }}
        </mapfre-button>
      </div>
    </div>
  </mapfre-modal>
</ng-container>

<div class="email-error-notification mb-4" *ngIf="showEmailAlreadyExistMsg">
  <span class="email-img">
    <img src="./assets/img/images/email_notification.svg" alt="email notification" />
  </span>
  <span class="email-txt-block">
    <p class="email-already-exists-head">Email already exists</p>
    <p class="email-already-exists-para">
      That email is already associated with another account, please log into
      that account or contact our customer service department for help.
    </p>
  </span>
  <span class="email-close" (click)="closeMe()">
    <img src="./assets/img/images/email_close.svg" alt="email close" />
  </span>
</div>
<div class="single-card-column policy-card edit-contact">
  <div class="row">
    <div class="col">
      <h1 class="edit-title mb-0" [ngClass]="{ 'acmic-title-color': isAcmic}">{{ "EDIT_CONTACT_DETAILS" | translate }}</h1>
      <hr class="mt-3 mb-3 border-width" />

      <section class="mt-4 mb-2" *ngIf="existActiveGWPolicy && showProfileImpNotice">
        <app-profile-imp-notice [theme]="'blue'" [notificationMsg]="notificationMsg" (closeIcon)="onClose($event)">
        </app-profile-imp-notice>
      </section>

      <form class="edit-contact-page" name="editContactForm" [formGroup]="editContactForm"
        (ngSubmit)="editContactForm.valid && editContact()">
        <div class="input">
          <div class="row email-input margin-bottom mb8 mapfre-input" [ngClass]="{'invalid-inc-height': isAcmic && isValid('contactEmail')}">
            <div class="col input-content">
              <div class="input-field mapfre">
                <input id="contactEmail" name="contactEmail" type="email" [formControlName]="'contactEmail'"
                  class="form-control" mdbInput #email />
                <div class="filter-input-lable">
                  <mapfre-label [forInput]="'contactEmail'" [validationCSSClass]="true">{{ "Email" }}
                  </mapfre-label>
                </div>
                <div class="help-block error-block" *ngIf="
                    !isEmptyField('contactEmail') && isValid('contactEmail')
                  ">
                  {{ "Enter a valid email address" | translate }}
                </div>
                <div class="help-block error-block" *ngIf="isEmptyField('contactEmail')">
                  {{ "Enter an email" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="existActiveGWPolicy; else legacyAs400Policies">
          <hr class="mt-4 mb-4 border-width" />
          <div class="text-left">Phones</div>
          <div class="input">
            <div class="row email-input margin-bottom mb8 mapfre-input" [ngClass]="{'invalid-inc-height': isAcmic && isValid('mobilePhone')}">
              <div class="col input-content">
                <div class="input-field mapfre">
                  <input type="tel" id="mobilePhone" [formatter]="phoneFormatter" InputMask name="mobilePhone"
                    [formControlName]="'mobilePhone'" class="form-control" mdbInput #email
                    (keyup)="onInput('mobilePhone', mobilePrimaryStatus)" />
                  <div class="filter-input-lable">
                    <mapfre-label [forInput]="'mobilePhone'" [validationCSSClass]="true">{{ "Mobile" }}
                    </mapfre-label>
                  </div>
                  <div class="help-block error-block" *ngIf="!isEmptyField('mobilePhone') && isValid('mobilePhone')">
                    {{ "Enter a valid mobile phone number" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="input mt-3" *ngIf="checkForSwitchAndRemove('mobilePhone')">
            <div class="row margin-bottom mb8">
              <div class="col input-content">
                <div class="input-field mapfre button-action">
                  <div class="contact-switch">
                    <section class="mat-slide-toggle-container">
                      <mapfre-slide-toggle
                        [checked]="mobilePrimaryStatus"
                        [disabled]="mobilePrimaryStatus && phoneCount === 1"
                        color="accent"
                        label="Primary"
                        [isAcmic]="isAcmic"
                        (toggleChange)="setAsPrimary($event, 'mobilePhone', mobilePrimaryStatus)">
                      </mapfre-slide-toggle>
                    </section>
                  </div>
                  <div class="remove-button" (click)="clearPhoneInput('mobilePhone', mobilePrimaryStatus)">
                    <mapfre-button additionalClasses="remove-btn ghost">{{
                      "REMOVE" | translate
                      }}</mapfre-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="input">
            <div class="row email-input margin-bottom mb8 mapfre-input" [ngClass]="{'invalid-inc-height': isAcmic && isValid('homePhone')}">
              <div class="col input-content">
                <div class="input-field mapfre">
                  <input id="homePhone" name="homePhone" type="tel" InputMask [formatter]="phoneFormatter"
                    [formControlName]="'homePhone'" class="form-control" mdbInput #email
                    (keyup)="onInput('homePhone', homePrimaryStatus)" />
                  <div class="filter-input-lable">
                    <mapfre-label [forInput]="'homePhone'" [validationCSSClass]="true">{{ "Home" }}
                    </mapfre-label>
                  </div>
                  <div class="help-block error-block" *ngIf="!isEmptyField('homePhone') && isValid('homePhone')">
                    {{ "Enter a valid home phone number" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="input mt-3" *ngIf="checkForSwitchAndRemove('homePhone')">
            <div class="row margin-bottom mb8">
              <div class="col input-content">
                <div class="input-field mapfre button-action">
                  <div class="contact-switch">
                    <section class="mat-slide-toggle-container">
                      <mapfre-slide-toggle
                        [checked]="homePrimaryStatus"
                        [disabled]="homePrimaryStatus && phoneCount === 1"
                        color="accent"
                        label="Primary"
                        [isAcmic]="isAcmic"
                        (toggleChange)="setAsPrimary($event, 'homePhone', homePrimaryStatus)">
                      </mapfre-slide-toggle>
                    </section>
                  </div>
                  <div class="remove-button" (click)="clearPhoneInput('homePhone', homePrimaryStatus)">
                    <mapfre-button additionalClasses="remove-btn ghost">{{
                      "REMOVE" | translate
                      }}</mapfre-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="input">
            <div class="row email-input margin-bottom mb8 mapfre-input" [ngClass]="{'invalid-inc-height': isAcmic && isValid('workPhone')}">
              <div class="col input-content">
                <div class="input-field mapfre">
                  <input id="workPhone" name="workPhone" type="tel" InputMask [formatter]="phoneFormatter"
                    [formControlName]="'workPhone'" class="form-control" mdbInput #email
                    (keyup)="onInput('workPhone', workPrimaryStatus)" />
                  <div class="filter-input-lable">
                    <mapfre-label [forInput]="'workPhone'" [validationCSSClass]="true">{{ "Work" }}
                    </mapfre-label>
                  </div>
                  <div class="help-block error-block" *ngIf="!isEmptyField('workPhone') && isValid('workPhone')">
                    {{ "Enter a valid work phone number" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="input mt-3" *ngIf="checkForSwitchAndRemove('workPhone')">
            <div class="row margin-bottom mb8">
              <div class="col input-content">
                <div class="input-field mapfre button-action">
                  <div class="contact-switch">
                    <section class="mat-slide-toggle-container">
                      <mapfre-slide-toggle
                        [checked]="workPrimaryStatus"
                        [disabled]="workPrimaryStatus && phoneCount === 1"
                        color="accent"
                        label="Primary"
                        [isAcmic]="isAcmic"
                        (toggleChange)="setAsPrimary($event, 'workPhone', workPrimaryStatus)">
                      </mapfre-slide-toggle>
                    </section>
                  </div>
                  <div class="remove-button" (click)="clearPhoneInput('workPhone', workPrimaryStatus)">
                    <mapfre-button additionalClasses="remove-btn ghost">{{
                      "REMOVE" | translate
                      }}</mapfre-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row margin-top mt24 text-right confirm-cancel-btns">
            <div class="col-md cancel-contact-btn">
              <mapfre-button [additionalClasses]="'ghost secondary medium-btn'"
                [translateValue]="'CANCEL_CONTACT' | translate" [routerLink]="['/profile/manage-contact-details']">{{
                "CANCEL_CONTACT" | translate }}</mapfre-button>
            </div>
            <div class="col-md-auto">
              <mapfre-button [ngClass]="{ 'edit-contact custom_loader': loader }"
                [additionalClasses]="'basic primary medium-btn'" [inputType]="'submit'"
                [disabledValue]="editContactForm.valid"
                [translateValue]="'CONFIRM_CONTACT' | translate"></mapfre-button>
            </div>
          <!-- </div>
          <div class="row margin-top mt24"> -->
          
        </div>
        </ng-container>
        <ng-template #legacyAs400Policies>
          <div class="row margin-top mt24 text-right confirm-cancel-btns">
            <div class="col-md cancel-contact-btn">
              <mapfre-button [additionalClasses]="'ghost secondary medium-btn'"
                [translateValue]="'CANCEL_CONTACT' | translate" [routerLink]="['/profile/manage-contact-details']">{{
                "CANCEL_CONTACT" | translate }}</mapfre-button>
            </div>
            <div class="col-md-auto">
              <mapfre-button [ngClass]="{ 'edit-contact custom_loader': loader }"
                [additionalClasses]="'basic primary medium-btn'" [inputType]="'submit'"
                [disabledValue]="editContactForm.valid && (!isPrimaryStatusSet() || !this.phoneCount)"
                [translateValue]="'CONFIRM_CONTACT' | translate"></mapfre-button>
            </div>
        </div>
        </ng-template>
      </form>
    </div>
  </div>
</div>